import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const newLocal = (
    <svg
      id="footer-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 75"
      fill="none"
    >
      <path />
    </svg>
  );
  return (
    <div>
      <footer className="footer-main">
        <div className="footer-bg-wrapper gray-bg">
          <div className="footer-shape shape-one">
            <span>
              <img src="assets/images/footer/shape-1.png" alt="shape" />
            </span>
          </div>
          {newLocal}

          <div className="footer-widget-area pb-80">
            <div className="container">
              <div className="row">
                <div className="col-xl-6 col-sm-6">
                  <div
                    className="footer-widget about-company-widget mb-40"
                    data-aos="fade-up"
                    data-aos-delay="10"
                    data-aos-duration="1000"
                  >
                    <div className="widget-content">
                      <Link to="/" className="footer-logo">
                        <img
                          src="assets/images/logo/logo-main.png"
                          alt="Brand Logo"
                        />
                      </Link>
                      <p>
                        DVELGE est un fournisseur international de technologies
                        et de solutions professionnelles, offrant des
                        équipements, systèmes numériques et services de haute
                        qualité aux entreprises du monde entier.
                      </p>
                      <ul className="ct-info-list mb-30">
                        <li>
                          <i className="fas fa-envelope"></i>
                          <a href="mailto:ventes@dvelgegroup.com">
                            ventes@dvelgegroup.com
                          </a>
                        </li>
                        <li>
                          <i className="fas fa-phone-alt"></i>
                          <a href="tel:+224627020871">+224627020871</a>
                        </li>
                      </ul>
                      <ul className="social-link">
                        <li>
                          <span>Suivez-nous :</span>
                        </li>
                        <li>
                          <a
                            href="https://www.facebook.com/dvelgegroup"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-facebook-f"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.instagram.com/dvelgegroup"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-instagram"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.linkedin.com/company/dvelgegroup"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://x.com/dvelgegroup"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-twitter"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.tiktok.com/@dvelgegroup"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-tiktok"></i>
                          </a>
                        </li>{" "}
                        <li>
                          <a
                            href="https://www.youtube.com/@dvelgegroup"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-youtube"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6 col-sm-6">
                  <div
                    className="footer-widget footer-nav-widget mb-40"
                    data-aos="fade-up"
                    data-aos-delay="20"
                    data-aos-duration="1400"
                  >
                    <div className="widget-content">
                      <h4 className="widget-title">Liens Rapides</h4>
                      <ul className="widget-menu">
                        <li>
                          <img
                            src="assets/images/icon/star-3.svg"
                            alt="star icon"
                          />
                          <Link to="/produits">Produits</Link>
                        </li>
                        <li>
                          <img
                            src="assets/images/icon/star-3.svg"
                            alt="star icon"
                          />
                          <Link to="/achat-externalise">Achat Externalise</Link>
                        </li>
                        <li>
                          <img
                            src="assets/images/icon/star-3.svg"
                            alt="star icon"
                          />
                          <Link to="https://www.dvelgegroup.com">
                            Site Principal
                          </Link>
                        </li>
                        <li>
                          <img
                            src="assets/images/icon/star-3.svg"
                            alt="star icon"
                          />
                          <Link to="https://logiciel.dvelgegroup.com">
                            Site Logiciel
                          </Link>
                        </li>
                        <li>
                          <img
                            src="assets/images/icon/star-3.svg"
                            alt="star icon"
                          />
                          <Link to="https://formation.dvelgegroup.com">
                            Site Formation
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="copyright-area">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="copyright-text">
                    <p>
                      &copy; 2026 fourniture.dvelgegroup.com. Tous droits
                      réservés par <span> DVELGE Group</span>
                    </p>
                  </div>
                </div>
                {/* <div className="col-lg-6">
                         <div className="payment-method text-lg-end">
                             <a href="#"><img src="assets/images/footer/payment-method.png" alt="payment-method"/></a>
                         </div>
                     </div> */}
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* <div className="back-to-top"><i className="far fa-angle-up"></i>
 </div> */}
    </div>
  );
};

export default Footer;
